

<div class="btn-group" style="width: 400px;">
        <button class="btn btn-primary" (click)="onGoToPage(1)" [disabled]="currentPage === 1"><i
                        class="fa fa-chevrons-left"></i></button>
        <button class="btn btn-primary" (click)="onGoToPage(currentPage - 1)" [disabled]="currentPage === 1"><i
                        class="fa fa-chevron-left"></i></button>

        <!-- gotopage -->
        @for (page of pages; track $index) {
        <button class="btn btn-secondary" [ngClass]="{'active': page === currentPage}" (click)="onGoToPage(page)">
                {{ page }}
        </button>
        }
        @empty {
        <button class="btn btn-secondary" disabled>No pages</button>
        }

        <button class="btn btn-primary" (click)="onGoToPage(currentPage + 1)" [disabled]="currentPage === totalPages"><i
                        class="fa fa-chevron-right"></i></button>
        <button class="btn btn-primary" (click)="onGoToPage(totalPages)" [disabled]="currentPage === totalPages"><i
                        class="fa fa-chevrons-right"></i></button>
</div>
